import { Component } from '@angular/core';

@Component({
  selector: 'app-cancellation-requests',
  imports: [],
  templateUrl: './cancellation-requests.component.html',
  styleUrl: './cancellation-requests.component.scss'
})
export class CancellationRequestsComponent {

}
